<template>
  <div
    v-if="podcasts.length"
    class="more-of-category"
  >
    <PodcastList
      :key="1"
      :bucket="{
        name: `More in ${category.name}`,
        items: podcasts,
        bucket_type: 'podcasts',
        media_size: 'thumbnail',
      }"
      :display-name="false"
      type="podcast"
    />
  </div>
</template>

<script>
import PodcastService from '../services/Podcast';
import PodcastList from './PodcastList';

export default {
  components: {
    PodcastList,
  },
  props: {
    category: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      podcastService: new PodcastService(),
      podcasts: [],
    };
  },
  mounted() {
    if (this.category) {
      this.podcastService.getPodcastByCategoryId(this.category.uuid, 25, 1)
        .then((resp) => {
          this.podcasts = resp.podcast;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
  .more-of-category {
    margin: 25px 0 60px;

    h3 {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// app/src/components/MoreOfCategory.vue